(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rumbo-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
var els=document.querySelectorAll('.reveal');
if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('in')});return}
var io=new IntersectionObserver(function(entries){entries.forEach(function(en){if(en.isIntersecting){en.target.classList.add('in');io.unobserve(en.target)}})},{threshold:0.15});
els.forEach(function(e){io.observe(e)});
})();
(function(){
var lines=document.querySelectorAll('.fade-line');
if(!('IntersectionObserver' in window)){lines.forEach(function(e){e.classList.add('seen')});return}
var io2=new IntersectionObserver(function(entries){entries.forEach(function(en){if(en.isIntersecting){en.target.classList.add('seen');io2.unobserve(en.target)}})},{rootMargin:'-40% 0px -40% 0px',threshold:0});
lines.forEach(function(e){io2.observe(e)});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rumbo-product-main"] && !Shopify.designMode) return;
  try {
    
(function(){
  var heroCta = document.querySelector('.precio-cta');
  var stickyBars = document.querySelectorAll('[id^="stickyBuyBar-"]');
  if (!heroCta || !stickyBars.length || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      stickyBars.forEach(function(bar){ bar.classList.toggle('visible', !entry.isIntersecting); });
    });
  }, { threshold: 0 });
  io.observe(heroCta);
})();

(function(){
  var track = document.getElementById('carouselTrack');
  var prev = document.getElementById('carouselPrev');
  var next = document.getElementById('carouselNext');
  var dotsWrap = document.getElementById('carouselDots');
  if (!track || !prev || !next || !dotsWrap) return;

  var cards = Array.prototype.slice.call(track.querySelectorAll('.testimonial-card'));
  var currentIndex = 0;
  var isAnimating = false;
  var rafId = null;

  cards.forEach(function(_, i){
    var dot = document.createElement('button');
    dot.type = 'button';
    dot.className = 'carousel-dot' + (i === 0 ? ' active' : '');
    dot.setAttribute('aria-label', 'Ir a reseña ' + (i + 1));
    dot.addEventListener('click', function(){ goTo(i); });
    dotsWrap.appendChild(dot);
  });
  var dots = dotsWrap.querySelectorAll('.carousel-dot');

  function setActiveDot(i){
    dots.forEach(function(d, di){ d.classList.toggle('active', di === i); });
  }

  function easeInOutCubic(t){
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function animateScrollTo(target, duration){
    if (rafId !== null) { cancelAnimationFrame(rafId); rafId = null; }
    var start = track.scrollLeft;
    var distance = target - start;
    var startTime = null;
    isAnimating = true;
    function step(timestamp){
      if (!startTime) startTime = timestamp;
      var elapsed = timestamp - startTime;
      var progress = Math.min(elapsed / duration, 1);
      track.scrollLeft = start + distance * easeInOutCubic(progress);
      if (progress < 1) {
        rafId = requestAnimationFrame(step);
      } else {
        isAnimating = false;
        rafId = null;
      }
    }
    rafId = requestAnimationFrame(step);
  }

  function goTo(i){
    i = Math.max(0, Math.min(i, cards.length - 1));
    currentIndex = i;
    var card = cards[i];
    var target = card.offsetLeft - track.offsetLeft;
    animateScrollTo(target, 400);
    setActiveDot(i);
  }

  prev.addEventListener('click', function(){ goTo(currentIndex - 1); });
  next.addEventListener('click', function(){ goTo(currentIndex + 1); });

  var scrollTimeout;
  track.addEventListener('scroll', function(){
    if (isAnimating) return;
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(function(){
      var closest = 0;
      var minDist = Infinity;
      cards.forEach(function(card, i){
        var dist = Math.abs((card.offsetLeft - track.offsetLeft) - track.scrollLeft);
        if (dist < minDist) { minDist = dist; closest = i; }
      });
      currentIndex = closest;
      setActiveDot(closest);
    }, 100);
  }, { passive: true });
})();

  } catch(e) { console.error(e); }
})();
})();
